export default "__VITE_ASSET__DhZamC16__"